const projects = [

  {
     title: "Customer Reletionship Management",
    category: "Software",
    text: "Web-based business application using Java, Spring Boot and React."
  },

  {
     title: "Human Resource Management System",
    category: "Software",
    text: "Web-based business application using Java, Spring Boot and React."
  },

  {
    title: "Business Management System",
    category: "Software",
    text: "Web-based business application using Java, Spring Boot and React."
  },

  {
    title: "E-Commerce Application",
    category: "Web Development",
    text: "Full-stack e-commerce application with authentication and admin panel."
  },
   {
    title: "MOVIE DB PANEL",
    category: "Web Development",
    text: "Web application with moviedb database to manage panel."
  }

];

function Projects() {

  return (

    <section id="projects" className="section projects">

      <div className="section-title">

        <p>OUR WORK</p>

        <h2>Projects</h2>

      </div>

      <div className="project-grid">

        {projects.map((project, index) => (

          <div className="project-card" key={index}>

            <span>{project.category}</span>

            <h3>{project.title}</h3>

            <p>{project.text}</p>

            <button>
              View Project
            </button>

          </div>

        ))}

      </div>

    </section>

  );
}

export default Projects;